<template>
  <v-dialog
    v-model="getCotizadorConfigs.dialogAgregarProductoEnabled"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="secondary">
        <v-toolbar-title>Agregar productos a la cotización... {{getCotizadorConfigs.sucClaveSelected}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="dialogClose" class="pr-4">
            <v-icon class="pr-6">far fa-check-circle</v-icon>Listo
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container grid-list-md fluid>
        <imageDetail></imageDetail>
        <v-layout row class="pt-2">
          <v-flex xs12>
            <v-row no-gutters>
              <v-col cols="4">
                <v-tooltip v-model="showCentroInterlocutor" top>
                  <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                      <v-icon class="pr-2" color="grey lighten-1">fas fa-cart-plus</v-icon>
                      <span class="overline">Centro del interlocutor:</span>
                      <span
                        class="caption primary--color font-weight-bold pl-2"
                      >{{getActualCotizacionInterlocutorDetalle.SucClave}} {{getCotizadorConfigs.disponibleInterlocutorSucClave}}</span>
                    </v-btn>
                  </template>
                  <span>Aqui va ir el listado de codigos...</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4">
                <v-tooltip v-model="showCentroDisponibles" top>
                  <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                      <v-icon class="pr-2" color="grey lighten-1">fas fa-cart-plus</v-icon>
                      <span class="overline">Centro con más disponibles:</span>
                      <span
                        class="caption primary--color font-weight-bold pl-2"
                      >{{getCotizadorConfigs.sucClaveMasDisponibilidad.sucClave }} {{getCotizadorConfigs.sucClaveMasDisponibilidad.qty}}</span>
                    </v-btn>
                  </template>
                  <span>Aqui va ir el listado de codigos...</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  class="pr-1 overline"
                  x-small
                  dense
                  v-model="filtroIndividual"
                  :append-outer-icon="!filtroIndividual ? 'search' : 'send'"
                  @click:append-outer="buscaIndividual"
                  @keyup.enter="buscaIndividual"
                  label="Buscar producto"
                  type="text"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-flex>

          <v-flex v-for="product in getListaTemporalProductos" v-bind:key="product.nid" xs12>
            <productdetail :product="product"></productdetail>
          </v-flex>
          <v-flex xs12>
            <v-row no-gutters>
              <v-col cols="6">
                <listaProductoSucClave
                  :title="'Centro del interlocutor'"
                  :sucClave="getActualCotizacionInterlocutorDetalle.SucClave"
                  :itemsQty="getCotizadorConfigs.disponibleInterlocutorSucClave"
                ></listaProductoSucClave>
              </v-col>
              <v-col cols="6">
                <listaProductoSucClave
                  :title="'Sucursal Mayor Disponibilidad'"
                  :sucClave="getCotizadorConfigs.sucClaveMasDisponibilidad.sucClave"
                  :itemsQty="getCotizadorConfigs.sucClaveMasDisponibilidad.qty"
                ></listaProductoSucClave>
              </v-col>
            </v-row>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <floatingCotizacion></floatingCotizacion>
  </v-dialog>
</template>
<script>
  import productdetail from "./productoDetalle";
  import floatingCotizacion from "./floatingActualCotization";
  import listaProductoSucClave from "./listaProductosSucClave";
  import imageDetail from "../../common/radecProductImage";
  import { mapGetters } from "vuex";
  export default {
    components: {
      productdetail,
      floatingCotizacion,
      imageDetail,
      listaProductoSucClave
    },

    data() {
      return {
        showCentroInterlocutor: false,
        showCentroDisponibles: false,

        bottom: false,
        dialog: true,
        loadingTable: false,
        search: "",

        filtrosBuscar: "",
        filtroIndividual: "",
        filtroInterno: ""
      };
    },
    created() {
      window.addEventListener("scroll", () => {
        this.bottom = this.bottomVisible();
      });
    },
    computed: mapGetters([
      "getMarcas",
      "getModelos",
      "getTaxonomy",
      "getListaProductos",
      "isCliente",
      "listaPrecios",
      "getCotizadorConfigs",
      "getListaTemporalProductos",
      "getActualCotizacionInterlocutorDetalle"
    ]),
    watch: {
      bottom(bottom) {
        if (bottom) {
          this.loadingTable = true;
          console.log("Pressionado bottom");
          if (
            this.getListaTemporalProductos.length <
            this.getListaTemporalProductos.length
          ) {
            this.addBeer();
          } else {
            console.log(
              `Fin de articulos... Lista: ${this.getListaTemporalProductos.length} TotalArticulos: ${this.getListaProductos.length}`
            );
            this.loadingTable = false;
          }
        }
      }
    },
    mounted() {
      this.$store.commit("updateListaProductosTemporal", []);
      this.$store.commit("cleanMayorDisponibilidad", "2");
    },
    methods: {
      dialogClose() {
        this.getCotizadorConfigs.dialogAgregarProductoEnabled = false;
        this.$store.getters.getCotizadorConfigs.disponibleInterlocutorSucClave = 0;
        this.$store.commit("updateListaProductosTemporal", []);
        this.$store.commit("cleanMayorDisponibilidad", "2");
        this.filtroInterno = "";
        this.filtroIndividual = "";
      },

      bottomVisible() {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight;
        // console.log(
        //   `Scrolly: ${scrollY}, bottomOfPage:${bottomOfPage} Page Height: ${pageHeight}, Visible: ${visible}`
        // );
        return bottomOfPage || pageHeight < visible;
      },
      addBeer() {
        const _ = require("lodash");
        var pg = this.page,
          pgSize = 64,
          offset = (pg - 1) * pgSize,
          pagedItems = _.drop(this.getListaProductos, offset).slice(0, pgSize);

        this.getListaTemporalProductos.push(...pagedItems);

        this.page++;
        this.loadingTable = false;
      },

      buscaIndividual() {
        this.filtrosBuscar = `search=${this.filtroIndividual}&op=Buscar`;
        this.$store
          .dispatch("getListaProductos", this.filtrosBuscar)
          .then(res => {
            this.loadingTable = false;
            this.page = 0;
            this.addBeer();
          })
          .catch(e => {
            console.log(e);
          });
      }
    }
  };
</script>
